import { render, staticRenderFns } from "./CountryRegionForm.vue?vue&type=template&id=c54cea40&"
import script from "./CountryRegionForm.vue?vue&type=script&lang=js&"
export * from "./CountryRegionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports